<template>
  <ConfirmationAlert />
  <SubscriptionModal />
  <NotificationToast />
  <OffcanvasViews />
  <ChatRoomModal />
  <Specialties />
  <Approaches />
  <router-view />
  <AppointmentRating />
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from "vue";
import NotificationToast from "@/components/NotificationToast.vue";
import { toggleModal, toggleOffcanvas } from "@/utils/Helper";
import { pusherService } from "@/di/pusher";
import pkg from "../package.json";
import { startFirebase } from "./firebaseinit";
import { useOffcanvasStore } from "./store/useOffcanvasStore";
import { useChatRoomConfigStore } from "./store/useChatRoomConfigStore";
import { useAppointmentRatingPendingStore } from "./store/useAppointmentRatingPendingStore";
import AppointmentRating from "./views/Appointments/AppointmentRating/AppointmentRating.vue";
import ChatRoomModal from "./views/Chat/ChatRoom/ChatRoomModal.vue";
import Approaches from "./views/Modals/Approaches/Approaches.vue";
import Specialties from "./views/Modals/Specialties/Specialties.vue";
import SubscriptionModal from "./views/Modals/SubscriptionModal/SubscriptionModal.vue";
import OffcanvasViews from "./views/OffcanvasViews/OffcanvasViews.vue";

document.title = "Psiapp Pro | Web";

const offcanvasStore = useOffcanvasStore();
const chatRoomConfigStore = useChatRoomConfigStore();
const appointmentRatingPendingStore = useAppointmentRatingPendingStore();
const chatId = computed(() => chatRoomConfigStore.config?.id);
const chatMode = computed(() => chatRoomConfigStore.config?.mode);
const offcanvasPath = computed(() => offcanvasStore.config?.path);
const appointmentRatingPending = computed(
  () => appointmentRatingPendingStore.pending,
);

onMounted(() => {
  if (offcanvasPath.value) {
    toggleOffcanvas("offcanvas_views");
  }
  if (chatId.value && chatMode.value === "modal") {
    toggleModal("chat_room");
  }
  if (appointmentRatingPending.value) {
    toggleModal("appointment_rating_pending");
  }

  console.log("VERSION: ", `${pkg.version} ${process.env.VUE_APP_ENV_NAME}`);
  pusherService.connect();

  /**
   * NOTE: SPRINT 26
   * ITEM 1201
   * app criado na conta da phurshell, fiz igual o psi pacientes e so funciona em prod
   * os dados do FB estao como autoday... não me pergunte
   */
  startFirebase();
});

onUnmounted(() => {
  pusherService.disconnect();
});
</script>
